module.exports = __webpack_public_path__ + "img/cup2.6fde3ed7.png";